
import { FrontApi } from '../../../api/front-api/front.api'
import StepperCustom from '../../../components/step/Stepper'
import { Box, Divider, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { ContainerBox, ProfileCard } from './element/element'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store/store'
import Hashids from 'hashids'

import { setLoading, unsetLoading } from '../../../store/loading/loading.slice'
import { useNavigate } from 'react-router-dom'
import { routeName } from '../../../routes/routeName'
import { useTranslation } from 'react-i18next'
import { languageEnum } from '../../../constants/enum'

type Props = {}

type departmentList = {
    id_department: number | null,
    department_name_th: string;
    department_name_eng: string;
    status: string;
    id_department_ref: number | null
}
type employeeList = {
    buddhist_name: string;
    file_mime_type: string | null;
    file_name: string | null;
    file_path: string | null;
    first_name: string | null;
    id_employee: number | null;
    last_name: string;
    position_name: string;
}

const Organizational: React.FC = ({ }: Props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const language = i18n.language as languageEnum;


    const [step, setStep] = useState<number>(0);
    const [departmentData, setDepartmentData] = useState<departmentList[]>([]);
    const [employeeData, setEmployeeData] = useState<employeeList[]>([]);
    const [id_department, set_id_department] = useState<number | null>(null);

    const public_img = useSelector((state: RootState) => state.api.image_api);



    // FUNC
    const handleGetDepartmentList = async () => {
        await FrontApi.departmentList().then((res) => {
            if (res.status < 300) {
                const data: departmentList[] = res.data?.data || [];
                setDepartmentData(data);
                if (data?.length > 0) {
                    const id_f_department: number = data?.find((x) => x)?.id_department!
                    set_id_department(id_f_department)
                }
            }
        }).catch((err) => console.log(err))
    }
    const handleGetEmployeeList = useCallback(async (id_department: number) => {
        dispatch(setLoading());
        await FrontApi.employeeDepartmentList(id_department).then((res) => {
            if (res.status < 300) {
                const emp_data = res.data?.data || [];
                setEmployeeData(emp_data);
            }
        }).catch((err) => {
            setEmployeeData([]);
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [id_department])

    useEffect(() => {
        handleGetDepartmentList();
    }, [])

    useEffect(() => {
        if (id_department) {
            handleGetEmployeeList(id_department);
        }
    }, [handleGetEmployeeList])

    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);
    const encodeId = (id_employee: number) => {
        const id = hash_ids.encode(id_employee);
        navigate(routeName.main.organizationDetail.replace(":id", id))
    }


    const RenderDepartment = (data: any[]) => {
        return (
            <Box className="flex flex-col justify-center items-center gap-8 w-full">
                {data?.map((x, index) => {
                    const employees = x?.employees as any[];
                    const children = x?.children as any[];
                    return (
                        <Box className="w-full" key={index}>
                            {employees?.length > 0 && (
                                <>
                                    <Divider sx={{ my: 2 }} />
                                    <Typography variant='h4'>
                                        {x?.department_name_eng || x?.department_name_th || "-"}
                                    </Typography>
                                </>
                            )}
                            <Box className="flex flex-wrap justify-center items-center gap-8 w-full">
                                {employees?.map((list, i) => {
                                    const keys = `${i}_${x?.id_employee}`
                                    const img_path: string = list?.file_path ? `${public_img}/${list?.file_path}` : "";
                                    return (
                                        <React.Fragment key={keys}>
                                            <ProfileCard
                                                key={keys}
                                                onClick={() => {
                                                    if (list.id_employee) {
                                                        encodeId(list.id_employee)
                                                    }
                                                }}
                                                data={{
                                                    description: list?.position_name || "",
                                                    first_name: list?.first_name || "",
                                                    last_name: list?.last_name || "",
                                                    img_src: img_path,
                                                    img_alt: t('HOME_PAGE_COURSE_INSTRUCTOR_(PROFESSOR)')
                                                }}
                                            />
                                        </React.Fragment>
                                    )
                                })}
                                <Divider
                                />
                                {RenderDepartment(children)}
                            </Box>
                        </Box>
                    )
                })}
            </Box>
        )
    }

    // UI
    return (
        <ContainerBox className="w-full flex justify-start flex-col items-center py-10">
            <Box className="flex flex-col px-10 gap-2 justify-center items-center">
                <Typography lineHeight={"54px"} variant='h3'>
                    {t("HOME_PAGE_IBSC_ORGANIZATION_CHART")}
                </Typography>
                <Typography textAlign={"center"} lineHeight={"21px"}>
                    {t("HOME_PAGE_ORGANIZATIONAL_CHART_OF_THE_INTERNATIONAL_BUDDHIST_STUDIES_COLLEGE_(IBSC),_MAHACHULALONGKORNRAJAVIDYALAYA_UNIVERSITY_(MCU)")}
                </Typography>
            </Box>

            <Box component={"section"}>
                <StepperCustom
                    setStep={(st) => {
                        if (id_department) {
                            const id_select_department = departmentData[st]?.id_department;
                            set_id_department(id_select_department);
                        }
                        setStep(st);
                    }}
                    step={step}
                    view
                    sx={{ maxWidth: { xs: "300px", sm: "500px", xl: "1200px" } }}
                    mode='tab'
                    stepLabel={
                        departmentData?.map((list) => {
                            return {
                                isAccept: true,
                                name: language === languageEnum.TH ? list.department_name_th : list.department_name_eng || "-",
                            }
                        })
                    }
                />
            </Box>

            <Box className="flex flex-wrap gap-10 w-full">
                {employeeData?.map((x: any, i) => {
                    const employees = x?.employees as any[];
                    const children = x?.children as any[];
                    return (
                        <Box className="flex flex-wrap justify-center items-center gap-8 w-full">
                            {employees?.map((list) => {
                                const keys = `${i}_${x?.id_employee}`
                                const img_path: string = list?.file_path ? `${public_img}/${list?.file_path}` : "";
                                return (
                                    <React.Fragment key={keys}>
                                        <ProfileCard
                                            key={keys}
                                            onClick={() => {
                                                if (list.id_employee) {
                                                    encodeId(list.id_employee)
                                                }
                                            }}
                                            data={{
                                                description: list?.position_name || "",
                                                first_name: list?.first_name || "",
                                                last_name: list?.last_name || "",
                                                img_src: img_path,
                                                img_alt: t('HOME_PAGE_COURSE_INSTRUCTOR_(PROFESSOR)')
                                            }}
                                        />
                                    </React.Fragment>
                                )
                            })}
                            <Divider
                            />
                            {RenderDepartment(children)}
                        </Box>
                    )
                })}
            </Box>
        </ContainerBox>
    )
}

export default Organizational